// extracted by mini-css-extract-plugin
module.exports = {"jobCard":"JobCard_jobCard__20PDu","jobCardPosition":"JobCard_jobCardPosition__1j5-z","jobCardLocation":"JobCard_jobCardLocation__1bcFC"};